import { lazy } from "react";

export { POST_MODERATION_PATH } from "./path";
export const PostModerationPage = lazy(() => import("./page"));
